import GlobalSearchController from './global_search_controller';
import rad_calendar_controller from './rad_calendar_controller';
import RemoteFormController from './remote_form_controller';
import SearchController from './search_controller';
import SearchDateFilterController from './search_date_filter_controller';
import SearchMatchTypeFilterController from './search_match_type_filter_controller';
import ToastController from './toast_controller';
import TimezoneDetectionController from './timezone_detection_controller';
import LlmChatFormController from './llm_chat_form_controller';
import InvitationFormController from './invitation_forms_controller';
import CollapseStateController from './collapse_state_controller';
import ClipboardController from './clipboard_controller';
import FormulaEditorController from './rad_reports/formula_editor_controller';
import ReportBuilderController from './rad_reports/report_builder_controller';
import ReportTreeController from './rad_reports/report_tree_controller';
import SortableController from './rad_reports/sortable_controller';
import CalculatedColumnFormController from './rad_reports/calculated_column_form_controller';
import RadReportFilterFormController from './rad_reports/filter_form_controller';
import RadReportAggregateFormController from './rad_reports/aggregate_form_controller';
import CalculatedMeasureFormController from './rad_reports/calculated_measure_form_controller';
import ConfigEditorController from './rad_reports/config_editor_controller';
import LazyContainerController from './lazy_container_controller';
import FieldFilterController from './rad_reports/field_filter_controller';

export const radControllers = [
  { id: 'global-search', controller: GlobalSearchController },
  { id: 'rad-calendar', controller: rad_calendar_controller },
  { id: 'remote-form', controller: RemoteFormController },
  { id: 'search', controller: SearchController },
  { id: 'search-date-filter', controller: SearchDateFilterController },
  { id: 'search-match-type-filter', controller: SearchMatchTypeFilterController },
  { id: 'toast', controller: ToastController },
  { id: 'timezone-detection', controller: TimezoneDetectionController },
  { id: 'llm-chat-form', controller: LlmChatFormController },
  { id: 'invitation-form', controller: InvitationFormController },
  { id: 'collapse-state', controller: CollapseStateController },
  { id: 'clipboard', controller: ClipboardController },
  { id: 'formula-editor', controller: FormulaEditorController },
  { id: 'report-builder', controller: ReportBuilderController },
  { id: 'report-tree', controller: ReportTreeController },
  { id: 'sortable', controller: SortableController },
  { id: 'calculated-column-form', controller: CalculatedColumnFormController },
  { id: 'rad-report-filter-form', controller: RadReportFilterFormController },
  { id: 'rad-report-aggregate-form', controller: RadReportAggregateFormController },
  { id: 'calculated-measure-form', controller: CalculatedMeasureFormController },
  { id: 'config-editor', controller: ConfigEditorController },
  { id: 'lazy-container', controller: LazyContainerController },
  { id: 'field-filter', controller: FieldFilterController }
];
